import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const blogsApi = createApi({
  reducerPath: "blogApis",
  baseQuery,
  tagTypes: ["blog", "blogDetail"],
  endpoints: (builder) => ({
    getBlogList: builder.query({
      query: ({ page = 1, tags = [] }) => {
        const tagsQuery = tags.map(tag => `tags[]=${encodeURIComponent(tag)}`).join('&');
        return `/blog?page=${page}${tags.length ? `&${tagsQuery}` : ''}`;
      },
      providesTags: ["blog"],
    }),
    getBlogDetail: builder.query({
      query: (slug) => `/blog/${slug}`,
      providesTags: ["blogDetail"],
    }),
  }),
});

export const { useLazyGetBlogDetailQuery, useLazyGetBlogListQuery, useGetBlogListQuery } = blogsApi;
